/**
 * List of feature flags - the name matches the feature flags' keys in Launch
 * Darkly and the feature-flag Redux state
 */

export const FEATURE_FLAG_ONBOARDING_VIDEO = 'sparxweb-onboarding-video';

export const FEATURE_FLAG_VIDEO_CHEAT_CODE = 'sparxweb-video-cheat-code';

// Flag to determine what curriculums a student can see in revision. Values can be `ks3`,
// `gcse` or `ks3,gcse`. If the flag is not set then `gcse` is the default.
export const FEATURE_FLAG_REVISION_CURRICULUM = 'sparxweb-revision-curriculum';

// Which method of written answer checks is enabled. Note, this flag is mostly used server-side,
// but we hide bookwork codes if the value is 'disabled'
export const FEATURE_FLAG_WAC_METHOD = 'sparxweb-wac-method';
export const WAC_METHOD_DISABLED = 'disabled';

/**
 * Allowed values for the mini game continue option
 */

export const FF_OPTION_MINI_GAME_CARD = 'card';

export const FF_OPTION_MINI_GAME_CARD_AND_BAR = 'both';

export const FF_OPTION_MINI_GAME_BAR = 'bar';

export const FF_OPTION_MINI_GAME_NO_CONTINUE = 'none';

/**
 * Discovery primary feature flags.
 */

export const FEATURE_FLAG_ENABLED_GAMES = 'discovery-enabled-games';

export const FEATURE_FLAG_ENABLED_QUESTIONSETS = 'discovery-enabled-questionsets';

// When true, the times tables game select will be the new Nov 2022 layout design with a progress bar at the top.
// When false it will be the prototype design from 2019 with a progress wheel in the left-hand column.
export const FEATURE_FLAG_TIMESTABLES_SHOW_NEW_GAME_SELECT_LAYOUT =
    'timestables-show-new-game-select-layout';

export const FEATURE_FLAG_DAILY_TOKENS = 'discovery-daily-tokens';

export const FEATURE_FLAG_ABILITY_VALIDATION_ENABLED = 'discovery-ability-validation-enabled';

export const FEATURE_FLAG_HIDE_POTTED_DELIVERY_TIMER_FOR_CLUBS_UP_TO =
    'discovery-hide-potted-delivery-timer-for-clubs-up-to';

// Controls the I don't know button in questions - should either be an integer number of
// seconds delay before the I don't know button appears, or "n/a" if the I don't know
// button is not present
export const FEATURE_FLAG_I_DO_NOT_KNOW_BUTTON_DELAY = 'timestables-do-not-know-button-delay';

/**
 * Times tables fearture flags.
 */

// In 100-club, makes the timer less stressful by allowing the user to still enter an answer after
// it has run out
export const FEATURE_FLAG_100CLUB_STRESS_FREE_TIMER = 'timestables-100club-stress-free-timer';

// The path to a JSON file where variations to the special questions can be submitted
// example value: "special_questions/do_not_restrict_compound_questions"
export const FEATURE_FLAG_SPECIAL_QUESTION_VARIATIONS = 'timestables-special-question-variations';

export const FEATURE_FLAG_ALLOW_LUCKY_ORANGE = 'timestables-allow-lucky-orange';
export const FEATURE_FLAG_MIC_QUESTIONS_OPTION = 'timestables-mic-questions-option';

export const FEATURE_FLAG_TALK_TO_ME_DEBUG_BUTTON = 'timestables-talk-to-me-debug-button';

export const FEATURE_FLAG_MIC_NEEDS_ANSWER_ONLY = 'timestables-mic-needs-answer-only';
export const FEATURE_FLAG_MIC_CONCATENATES_INPUT = 'timestables-mic-concatenates-input';
export const FEATURE_FLAG_MIC_SPEECH_LANGUAGE = 'timestables-speech-language';

// a timestamp in the form of a string. When checking for medals, this will be the
// furthest point back in time when the game will search for
// e.g. if the date "2020-08-20T13:00:00" is provided, only check for medals
//      AFTER the week that includes that date
export const FEATURE_FLAG_LEAGUE_TABLES_MEDALS_START = 'timestables-league-table-medals-start';

// if true, show worldwide medals in league tables, otherwise hide them
export const FEATURE_FLAG_LEAGUE_TABLES_SHOW_WORLD_MEDALS =
    'timestables-league-table-show-world-medals';

export const FEATURE_FLAG_RESET_TO_FIRST_PASS_AFTER_TIME_AWAY =
    'timestables-reset-to-first-pass-after-time-away';

export const FEATURE_DIVISION_QUESTIONS_IN_POTTED_DELIVERY =
    'timestables-division-questions-in-potted-delivery';

export const FEATURE_FLAG_GAMES_MASTER_VOLUME_SLIDER = 'timestables-games-master-volume-slider';
export const FEATURE_FLAG_QUEUE_UNFINISHED_TALK_AND_LEARNS =
    'times-tables-queue-unfinished-talk-and-learns';

export const FEATURE_FLAG_SPARXWEB_SELENIUM_MODE = 'sparxweb-selenium-mode';

// TODO: remove discovery-practice.* flags

// Flag to override the asset server that the client will load content assets from - i.e. skill
// images and videos
export const FEATURE_FLAG_ASSET_SERVER_OVERRIDE = 'asset-server-override';

// Flag to override the asset server that the client will load non-bundled static assets from -
export const FEATURE_FLAG_STATIC_ASSET_SERVER_OVERRIDE = 'static-asset-server-override';

// Controls if the final frame poster is shown at the start of videos
// TODO: feature_flag: skill-video-disable-final-frame-at-start
export const FEATURE_FLAG_SKILL_VIDEO_DISABLE_FINAL_FRAME_AT_START =
    'skill-video-disable-final-frame-at-start';

// TODO: feature_flag: newuser-student-choose-password
export const FEATURE_FLAG_NEWUSER_STUDENT_CHOOSE_PASSWORD = 'newuser-student-choose-password';

// Returns which set of alias names to use for curriculum display names to use if any - for example,
// "australia".
export const FEATURE_FLAG_USE_CURRICULUM_ALIASES = 'use-curriculum-aliases';

// Whether the tracking features of Hotjar are enabled.
export const FEATURE_FLAG_HOTJAR_TRACKING = 'sparxweb-hotjar';

// Whether the feedback features of Hotjar are enabled.
export const FEATURE_FLAG_HOTJAR_FEEDBACK = 'sparxweb-hotjar-feedback';

// Whether to show the banner to students that allows them to submit feedback (via Hotjar).
export const FEATURE_FLAG_HOTJAR_FEEDBACK_BANNER = 'sparxweb-hotjar-feedback-banner';

// Whether a school is a Try Sparx school and will see an alternative student experience training module
export const FEATURE_FLAG_TRY_SPARX_SCHOOL = 'try-sparx-school';

// Whether to show the v2 version of Sparx Web
export const FEATURE_FLAG_SHOW_SPARX_WEB_V2 = 'sparxweb-show-sparxweb-v2';

// Whether to allow text to be selected, useful for text to speech.
export const FEATURE_FLAG_A11Y_SELECTABLE_TEXT = 'sparxweb-a11y-selectable-text';

// Whether to show UX improvements for Fast Track Quiz.
export const FEATURE_FLAG_FTQ_UX_IMPROVEMENTS = 'sparxweb-ftq-ux-improvements';

// Whether to allow homework to be completed in SW1
export const FEATURE_FLAG_ALLOW_HOMEWORK_IN_SW1 = 'sparxweb-allow-homework-in-sw1';
